/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InitiateMicroAuthCheckRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/MicroAuthVerification.pb'
import {InitiateMicroAuthCheckResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/MicroAuthVerification.pb'


export const initiateMicroAuthCheck = (request: InitiateMicroAuthCheckRequest, options?: CashRequestOptions) => post<InitiateMicroAuthCheckRequest, InitiateMicroAuthCheckResponse>("/2.0/cash/initiate-micro-auth-check", request, {...options, rejectOnError: true })